import * as io from 'io-ts';
import {TokenCodec} from './Token';

const LoginResponseData = io.type({token: TokenCodec});

export const LoginResponseDataCodec = LoginResponseData;

export type LoginResponseData = io.TypeOf<typeof LoginResponseData>;
